module.exports = __webpack_public_path__ + "static/media/coursera-01.1a58a3f3.png";